import type { FreeArea } from '@rubyplay/effw-connector';

type GamesToAreasCollection = {
    games: string[];
    areas: FreeArea[];
};

type FreeAreaWithHomeButtonOverride = FreeArea & {
    homeButtonEnabled?: Partial<Pick<
        FreeArea,
        'x' | 'y' | 'width' | 'height' | 'tooltipPosition' | 'bubbleAnimDirection'
    >>;
};

/**
    * Configuration for free areas for different games and platforms.
*/
const collections: GamesToAreasCollection[] = [
    // 3 Big Barrels Buffalo
    {
        games: ['kg_5536', 'kg_5507', 'kg_5505', 'kg_5006'],
        areas: [
            { id: '1', platform: 'desktop', orientation: 'landscape', x: 395, y: 117, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '2', platform: 'desktop', orientation: 'portrait', x: 395, y: 117, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '4', platform: 'mobile', orientation: 'portrait', x: 308, y: 3, width: 240, height: 240, tooltipPosition: 'bottom-left' },
            { id: '3', platform: 'mobile', orientation: 'landscape', x: 127, y: 41, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Búfalo da Fortuna
    {
        games: ['rp_201'],
        areas: [
            { id: '5', platform: 'desktop', orientation: 'landscape', x: 36, y: 18, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '6', platform: 'desktop', orientation: 'portrait', x: 36, y: 18, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '8', platform: 'mobile', orientation: 'portrait', x: 12, y: 12, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '7', platform: 'mobile', orientation: 'landscape', x: 12, y: 20, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Mad Hit Diamonds
    {
        games: ['rp_919', 'rp_735', 'rp_734', 'rp_733', 'rp_140'],
        areas: [
            { id: '9', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '10', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '12', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 32, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '11', platform: 'mobile', orientation: 'landscape', x: 12, y: 23, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 12, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Mad Hit Easter Eggsplosion
    {
        games: ['rp_906', 'rp_905', 'rp_904', 'rp_210'],
        areas: [
            { id: '13', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '14', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '16', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 31, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '15', platform: 'mobile', orientation: 'landscape', x: 12, y: 23, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 8, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Mad Hit Gold
    {
        games: ['rp_929', 'rp_928', 'rp_927', 'rp_215'],
        areas: [
            { id: '17', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '18', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '20', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 32, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '19', platform: 'mobile', orientation: 'landscape', x: 12, y: 23, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 14, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Mad Hit Ho Ho Hot Pudding
    {
        games: ['rp_862', 'rp_861', 'rp_190'],
        areas: [
            { id: '21', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '22', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '24', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 32, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '23', platform: 'mobile', orientation: 'landscape', x: 12, y: 23, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 12, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Diamond Explosion 7s
    {
        games: ['rp_146'],
        areas: [
            { id: '25', platform: 'desktop', orientation: 'landscape', x: 36, y: 102, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 36, y: 102, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '26', platform: 'desktop', orientation: 'portrait', x: 36, y: 102, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 36, y: 102, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '28', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 32, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '27', platform: 'mobile', orientation: 'landscape', x: 12, y: 210, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 6, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Mad Hit Supernova
    {
        games: ['rp_108'],
        areas: [
            { id: '29', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '30', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '32', platform: 'mobile', orientation: 'portrait', x: 12, y: 19, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '31', platform: 'mobile', orientation: 'landscape', x: 12, y: 23, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Immortal Ways Buffalo SE
    {
        games: ['rp_751', 'rp_736', 'rp_141'],
        areas: [
            { id: '33', platform: 'desktop', orientation: 'landscape', x: 36, y: 210, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '34', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '36', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 32, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '35', platform: 'mobile', orientation: 'landscape', x: 12, y: 70, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 12, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Immortal Ways Diamonds SE
    {
        games: ['rp_915', 'rp_754', 'rp_753', 'rp_145'],
        areas: [
            { id: '37', platform: 'desktop', orientation: 'landscape', x: 36, y: 210, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '38', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '40', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 32, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '39', platform: 'mobile', orientation: 'landscape', x: 12, y: 70, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 12, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // J Mania Lucky Pyggs
    {
        games: ['rp_835', 'rp_834', 'rp_177'],
        areas: [
            { id: '41', platform: 'desktop', orientation: 'landscape', x: 36, y: 231, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '42', platform: 'desktop', orientation: 'portrait', x: 36, y: 231, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '44', platform: 'mobile', orientation: 'portrait', x: 12, y: 14, width: 240, height: 240, tooltipPosition: 'none', homeButtonEnabled: { x: 8, y: 170, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '43', platform: 'mobile', orientation: 'landscape', x: 12, y: 70, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 12, y: 74, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Voltage Blitz Rapid
    {
        games: ['kg_5529', 'kg_5516', 'kg_5515', 'kg_5009'],
        areas: [
            { id: '45', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '46', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '48', platform: 'mobile', orientation: 'portrait', x: 308, y: 27, width: 240, height: 240, tooltipPosition: 'left' },
            { id: '47', platform: 'mobile', orientation: 'landscape', x: 12, y: 49, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Voltage Blitz Vortex
    {
        games: ['kg_5531', 'kg_5504', 'kg_5502', 'kg_5018', 'kg_5008', 'kg_5003', 'kg_5001', 'kg_5020'],
        areas: [
            { id: '49', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '50', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '52', platform: 'mobile', orientation: 'portrait', x: 308, y: 30, width: 240, height: 240, tooltipPosition: 'left' },
            { id: '51', platform: 'mobile', orientation: 'landscape', x: 12, y: 60, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Voltage Blitz Egypt
    {
        games: ['kg_5533', 'kg_5508', 'kg_5506', 'kg_5004'],
        areas: [
            { id: '53', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '54', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '56', platform: 'mobile', orientation: 'portrait', x: 308, y: 30, width: 240, height: 240, tooltipPosition: 'left' },
            { id: '55', platform: 'mobile', orientation: 'landscape', x: 12, y: 60, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Voltage Blitz Zeus Up
    {
        games: ['kg_5530', 'kg_5528', 'kg_5527', 'kg_5016'],
        areas: [
            { id: '57', platform: 'desktop', orientation: 'landscape', x: 42, y: 734, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '58', platform: 'desktop', orientation: 'portrait', x: 42, y: 734, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '60', platform: 'mobile', orientation: 'portrait', x: 308, y: 3, width: 240, height: 240, tooltipPosition: 'bottom-left' },
            { id: '59', platform: 'mobile', orientation: 'landscape', x: 11, y: 249, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    //Voltage Blitz Vortex Dynasty
    {
        games: ['kg_5008'],
        areas: [
            { id: '61', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '62', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '64', platform: 'mobile', orientation: 'portrait', x: 308, y: 30, width: 240, height: 240, tooltipPosition: 'left' },
            { id: '63', platform: 'mobile', orientation: 'landscape', x: 12, y: 60, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Crown Coins GT Tour
    {
        games: ['rp_920'],
        areas: [
            { id: '69', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '70', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '72', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 29, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '71', platform: 'mobile', orientation: 'landscape', x: 12, y: 23, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 12, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    //Bufón Fortuna
    {
        games: ['rp_194', 'rp_873', 'rp_907', 'rp_874'],
        areas: [
            { id: '73', platform: 'desktop', orientation: 'landscape', x: 36, y: 18, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '74', platform: 'desktop', orientation: 'portrait', x: 36, y: 18, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '76', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 31, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '75', platform: 'mobile', orientation: 'landscape', x: 12, y: 20, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 6, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Diamond Explosion 7s
    {
        games: ['rp_506', 'rp_505', 'rp_504', 'rp_72'],
        areas: [
            { id: '78', platform: 'desktop', orientation: 'landscape', x: 36, y: 102, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '79', platform: 'desktop', orientation: 'portrait', x: 36, y: 102, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '81', platform: 'mobile', orientation: 'portrait', x: 12, y: 27, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 32, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '80', platform: 'mobile', orientation: 'landscape', x: 12, y: 33, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 6, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Go High Panda
    {
        games: ['rp_917', 'rp_644', 'rp_643', 'rp_642', 'rp_109'],
        areas: [
            { id: '82', platform: 'desktop', orientation: 'landscape', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '83', platform: 'desktop', orientation: 'portrait', x: 36, y: 172, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '85', platform: 'mobile', orientation: 'portrait', x: 13, y: 17, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 74, y: 14, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '84', platform: 'mobile', orientation: 'landscape', x: 7, y: 24, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 6, y: 70, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Volcano Rising SE
    {
        games: ['rp_150', 'rp_763', 'rp_764', 'rp_918'],
        areas: [
            { id: '86', platform: 'desktop', orientation: 'landscape', x: 36, y: 93, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '87', platform: 'desktop', orientation: 'portrait', x: 36, y: 93, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '89', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right' , homeButtonEnabled: { x: 70, y: 33, width: 240, height: 240, tooltipPosition: 'right' }},
            { id: '88', platform: 'mobile', orientation: 'landscape', x: 12, y: 33, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 8, y: 88, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Volcano Rising
    {
        games: ['rp_58', 'rp_558', 'rp_559', 'rp_560', 'rp_561'],
        areas: [
            { id: '86', platform: 'desktop', orientation: 'landscape', x: 36, y: 93, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '87', platform: 'desktop', orientation: 'portrait', x: 36, y: 93, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '89', platform: 'mobile', orientation: 'portrait', x: 12, y: 31, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '88', platform: 'mobile', orientation: 'landscape', x: 12, y: 33, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 8, y: 88, width: 240, height: 240, tooltipPosition: 'right' } },
        ]
    },
    // Match Blitz Scatter Shock
    {
        games: ['rp_172', 'rp_883', 'rp_884', 'rp_885'],
        areas: [
            { id: '90', platform: 'desktop', orientation: 'landscape', x: 30, y: 176, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '91', platform: 'desktop', orientation: 'portrait', x: 30, y: 176, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '93', platform: 'mobile', orientation: 'portrait', x: 8, y: 14, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 6, y: 151, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '92', platform: 'mobile', orientation: 'landscape', x: 8, y: 81, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // J Mania Goal Nations
    {
        games: ['rp_228', 'rp_962', 'rp_963', 'rp_964'],
        areas: [
            { id: '41', platform: 'desktop', orientation: 'landscape', x: 39, y: 330, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '42', platform: 'desktop', orientation: 'portrait', x: 39, y: 330, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '44', platform: 'mobile', orientation: 'portrait', x: 8, y: 105, width: 240, height: 240, tooltipPosition: 'none' },
            { id: '43', platform: 'mobile', orientation: 'landscape', x: 8, y: 87, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Voltage Blitz Stars n Stripes
    {
        games: ['kg_5039', 'kg_5560', 'kg_5561', 'kg_5562'],
        areas: [
            { id: '86', platform: 'desktop', orientation: 'landscape', x: 56, y: 228, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '87', platform: 'desktop', orientation: 'portrait', x: 56, y: 228, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '89', platform: 'mobile', orientation: 'portrait', x: 308, y: 30, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '88', platform: 'mobile', orientation: 'landscape', x: 9, y: 87, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Voltage Blitz Heat Rush
    {
        games: ['kg_5551', 'kg_5027', 'kg_5550', 'kg_5549'],
        areas: [
            { id: '86', platform: 'desktop', orientation: 'landscape', x: 56, y: 228, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '87', platform: 'desktop', orientation: 'portrait', x: 56, y: 228, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '89', platform: 'mobile', orientation: 'portrait', x: 309, y: 23, width: 240, height: 240, tooltipPosition: 'left' },
            { id: '88', platform: 'mobile', orientation: 'landscape', x: 12, y: 81, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // J Mania 3 Loose Cannons
    {
        games: ['rp_236', 'rp_983', 'rp_982', 'rp_984'],
        areas: [
            { id: '41', platform: 'desktop', orientation: 'landscape', x: 18, y: 228, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '42', platform: 'desktop', orientation: 'portrait', x: 18, y: 228, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '44', platform: 'mobile', orientation: 'portrait', x: 8, y: 105, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '43', platform: 'mobile', orientation: 'landscape', x: 8, y: 77, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Giga Match Gems Party
    {
        games: ['rp_220', 'rp_946', 'rp_945', 'rp_964'],
        areas: [
            { id: '41', platform: 'desktop', orientation: 'landscape', x: 23, y: 453, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '42', platform: 'desktop', orientation: 'portrait', x: 23, y: 453, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '44', platform: 'mobile', orientation: 'portrait', x: 8, y: 14, width: 240, height: 240, tooltipPosition: 'right', homeButtonEnabled: { x: 70, y: 14, width: 240, height: 240, tooltipPosition: 'right' } },
            { id: '43', platform: 'mobile', orientation: 'landscape', x: 8, y: 83, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
    // Voltage Blitz King Ra
    {
        games: ['kg_5044', 'kg_5045', 'kg_5049', 'kg_5050'],
        areas: [
            { id: '57', platform: 'desktop', orientation: 'landscape', x: 42, y: 734, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '58', platform: 'desktop', orientation: 'portrait', x: 42, y: 734, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '60', platform: 'mobile', orientation: 'portrait', x: 308, y: 3, width: 240, height: 240, tooltipPosition: 'bottom-left' },
            { id: '59', platform: 'mobile', orientation: 'landscape', x: 11, y: 249, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },

    // // Brilliant Gems
    // {
    //     games: ['rp_850', 'rp_849', 'rp_15'],
    //     areas: [
    //         { id: '5 platform: 'desktop', orientation: 'landscape',', x: 50, y: 400, width: 300, height: 300 },
    //         { id: '6 platform: 'desktop', orientation: 'portrait',', x: 40, y: 400, width: 300, height: 300 },
    //         { id: '8 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '7 platform: 'mobile', orientation: 'landscape',', x: 50, y: 200, width: 300, height: 300 },
    //     ]
    // },
    // // J Mania Loco Habanero
    // {
    //     games: ['rp_913', 'rp_813', 'rp_812', 'rp_811', 'rp_166'],
    //     areas: [
    //         { id: '41 platform: 'desktop', orientation: 'landscape',', x: 50, y: 400, width: 300, height: 300 },
    //         { id: '42 platform: 'desktop', orientation: 'portrait',', x: 40, y: 400, width: 300, height: 300 },
    //         { id: '44 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '43 platform: 'mobile', orientation: 'landscape',', x: 50, y: 200, width: 300, height: 300 },
    //     ]
    // },
    // // Mayan Cache
    // {
    //     games: ['rp_626', 'rp_503', 'rp_502', 'rp_501', 'rp_32'],
    //     areas: [
    //         { id: '45 platform: 'desktop', orientation: 'landscape',', x: 10, y: 400, width: 300, height: 300 },
    //         { id: '46 platform: 'desktop', orientation: 'portrait',', x: 10, y: 400, width: 300, height: 300 },
    //         { id: '48 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '47 platform: 'mobile', orientation: 'landscape',', x: 10, y: 200, width: 300, height: 300 },
    //     ]
    // },
    // // Immortal Ways Volcano
    // {
    //     games: ['rp_799', 'rp_798', 'rp_797', 'rp_162'],
    //     areas: [
    //         { id: '37 platform: 'desktop', orientation: 'landscape',', x: 50, y: 400, width: 300, height: 300 },
    //         { id: '38 platform: 'desktop', orientation: 'portrait',', x: 40, y: 400, width: 300, height: 300 },
    //         { id: '40 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '39 platform: 'mobile', orientation: 'landscape',', x: 50, y: 200, width: 300, height: 300 },
    //     ]
    // },
    // // Diamond Explosion 7s SE
    // {
    //     games: ['rp_911', 'rp_768', 'rp_756', 'rp_755'],
    //     areas: [
    //         { id: '17 platform: 'desktop', orientation: 'landscape',', x: 50, y: 650, width: 300, height: 300 },
    //         { id: '18 platform: 'desktop', orientation: 'portrait',', x: 40, y: 650, width: 300, height: 300 },
    //         { id: '20 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '19 platform: 'mobile', orientation: 'landscape',', x: 50, y: 300, width: 300, height: 300 },
    //     ]
    // },
    // // Diamond Explosion Crown Coins
    // {
    //     games: ['rp_737'],
    //     areas: [
    //         { id: '21 platform: 'desktop', orientation: 'landscape',', x: 50, y: 400, width: 300, height: 300 },
    //         { id: '22 platform: 'desktop', orientation: 'portrait',', x: 40, y: 400, width: 300, height: 300 },
    //         { id: '24 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '23 platform: 'mobile', orientation: 'landscape',', x: 50, y: 200, width: 300, height: 300 },
    //     ]
    // },
    // // Elephant Stampede
    // {
    //     games: ['rp_521', 'rp_520', 'rp_519', 'rp_42'],
    //     areas: [
    //         { id: '25 platform: 'desktop', orientation: 'landscape',', x: 50, y: 400, width: 300, height: 300 },
    //         { id: '26 platform: 'desktop', orientation: 'portrait',', x: 40, y: 400, width: 300, height: 300 },
    //         { id: '28 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '27 platform: 'mobile', orientation: 'landscape',', x: 50, y: 200, width: 300, height: 300 },
    //     ]
    // },
    // // Giga Match Egypt
    // {
    //     games: ['rp_777', 'rp_776', 'rp_775', 'rp_153'],
    //     areas: [
    //         { id: '29 platform: 'desktop', orientation: 'landscape',', x: 50, y: 400, width: 300, height: 300 },
    //         { id: '30 platform: 'desktop', orientation: 'portrait',', x: 40, y: 400, width: 300, height: 300 },
    //         { id: '32 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '31 platform: 'mobile', orientation: 'landscape',', x: 50, y: 200, width: 300, height: 300 },
    //     ]
    // },
    // // Gummy Giga Match
    // {
    //     games: ['rp_689', 'rp_688', 'rp_687', 'rp_125'],
    //     areas: [
    //         { id: '33 platform: 'desktop', orientation: 'landscape',', x: 50, y: 400, width: 300, height: 300 },
    //         { id: '34 platform: 'desktop', orientation: 'portrait',', x: 40, y: 400, width: 300, height: 300 },
    //         { id: '36 platform: 'mobile', orientation: 'portrait',', x: 50, y: 150, width: 300, height: 300 },
    //         { id: '35 platform: 'mobile', orientation: 'landscape',', x: 50, y: 200, width: 300, height: 300 },
    //     ]
    // },
    // Default
    {
        games: ['default'],
        areas: [
            { id: '69', platform: 'desktop', orientation: 'landscape', x: 50, y: 400, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '70', platform: 'desktop', orientation: 'portrait', x: 50, y: 400, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '72', platform: 'mobile', orientation: 'portrait', x: 50, y: 150, width: 240, height: 240, tooltipPosition: 'right' },
            { id: '71', platform: 'mobile', orientation: 'landscape', x: 50, y: 200, width: 240, height: 240, tooltipPosition: 'right' },
        ]
    },
];

function scaleArea(area: FreeAreaWithHomeButtonOverride, isHomeButtonEnabled: boolean): FreeArea {
    const override = isHomeButtonEnabled ? area.homeButtonEnabled : undefined;
    const resolvedArea = {
        ...area,
        ...override,
    };

    const scale = resolvedArea.platform === 'desktop' ? 2 : 6;

    return {
        version: '1.0',
        gameName: 'ADD_FOR_DB_ENTRIES',
        ...resolvedArea,
        x: resolvedArea.x * scale,
        y: resolvedArea.y * scale,
        tooltipPosition: resolvedArea.tooltipPosition ?? 'right',
    };
}

export function getFreeAreas(gameName: string, isHomeButtonEnabled: boolean): FreeArea[] {
    const result = collections.find(collection => collection.games.includes(gameName))
        ?? collections.find(collection => collection.games.includes('default'));

    return (result?.areas ?? []).map(area => scaleArea(area, isHomeButtonEnabled));
}